import React, { useState, useEffect, useRef } from 'react';
import service from './services/service'
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

export const BmsHierarchicalQuery = (props) => {
    const toast = useRef(null);
    const [cities, setCitites] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [neighbourhoods, setNeighbourhoods] = useState([]);
    const [selectedNeighbourhod, setSelectedNeighbourhod] = useState(null);
    const [roads, setRoads] = useState([]);
    const [selectedRoad, setSelectedRoad] = useState(null);
    const [doorNumbers, setDoorNumbers] = useState([]);
    const [selectedDoorNumber, setSelectedDoorNumber] = useState(null);

    const [mapTool, setMapTool] = useState(null);
    useEffect(() => {

        window["hierarchicalToken"] = props.tokenKey;

        service.post(props.cityUrl, {}, props.bms).then(response => {
            if (!response.success) {
                if (props.isErrorMessage) {
                    console.log(response.message);
                }
                toast.current.show({ severity: 'error', detail: 'Hata oluştu' });
                return;
            }
            if (response.data.length)
                setCitites(response.data);
        }).catch(e => {
            if (props.isErrorMessage) {
                console.log(e);
            }
        });

        if (props.mapTool) {
            setMapTool(props.mapTool);
            let mapTool = props.mapTool;
            if (mapTool.findLayer(props.layerName) == null) {

                const layer = props.MapTool.createVectorLayer({
                    name: props.layerName,
                    source: props.MapTool.createVectorLayerSource({})
                });
                mapTool.addLayer(layer);
            }
        }
    }, []);
    const reset = () => {

        const citiesTemp = cities;
        if (props.isMultiple) {
            setSelectedCity([]);
            setSelectedDistrict([]);
            setSelectedNeighbourhod([]);
            setDoorNumbers([]);
            setRoads([]);
        }
        else {
            setSelectedCity({ id: -1 });
        }

        setDistricts([]);
        setNeighbourhoods([]);
        setDoorNumbers([]);
        setRoads([]);
        let addedLayers = [props.layerName];
        props.mapTool.clearLayersByName(addedLayers.map(x => x));


    }
    //Geometriyi oluştur ve göster
    const showWithGeojsonGeojson = (geojsonData, styleProp) => {
        if (geojsonData == null) {
            toast.current.show({ severity: 'error', detail: 'Geometri bulunamadı.' });
            return;
        }
        let datas = props.MapTool.convertGeoJsonToFeatures(geojsonData
            , (props.projection && props.projection.data ? props.projection.data : "EPSG:4326")
            , (props.projection && props.projection.feature ? props.projection.feature : "EPSG:3857"));

        mapTool.clearLayersByName([props.layerName]);
        for (var i = 0; i < datas.length; i++) {
            if (styleProp) {
                if (geojsonData.type !== "Point") {
                    datas[i].setStyle(mapTool.getBackgroundStyle(styleProp, { name: "" }));
                }
                else {
                    datas[i].setStyle(mapTool.setFeatureStyleIcon(styleProp, { name: "" }));
                }
            }
            mapTool.addFeature(props.layerName, datas[i]);
            if (styleProp.isExtend) {
                mapTool.viewLayerExtent(props.layerName);
            }
            if (styleProp.isOnlyExtend) {
                mapTool.viewLayerExtent(props.layerName, datas[i]);
            }
        }
        mapTool.viewLayerExtent(props.layerName);
    }
    //hangi katmana ekleneceği feature oluşturacak wkt stil varsa polygon sitili ve featurea eklencek info parametresi
    const getMap = (url, selfId, isGeoloc, style) => {
        service.post(url,
            {
                id: selfId, isGeoloc: isGeoloc
            }, props.bms).then(response => {
                if (!response.success) {
                    if (props.isErrorMessage) {
                        console.log(response.message);
                    }
                    toast.current.show({ severity: 'error', detail: 'Geometri bulunamadı' });
                    return;
                }
                if (response.data.geoloc) {
                    showWithGeojsonGeojson(response.data.geoloc, style);
                }

            }).catch(e => {
                if (props.isErrorMessage) {

                    console.log(e);
                }
            });

    }
    //İl idsi verilerek ilçeler getirilir
    const getDistricts = (value) => {
        service.post(props.districtUrl, { parentId: value.id }, props.bms).then(response => {
            if (!response.success) {
                if (props.isErrorMessage) {
                    console.log(response.message);

                }
                toast.current.show({ severity: 'error', detail: 'Hata oluştu' });
                return;
            }
            if (response.data.length)
                setDistricts(response.data);
        }).catch(e => {
            if (props.isErrorMessage) {

                console.log(e);
            }
        });
    }
    //İlçe idsi verilerek mahaller getirilir
    const getNeighbourhoods = (value) => {

        service.post(props.neighbourhoodUrl, { parentId: value.id }, props.bms).then(response => {
            if (!response.success) {
                if (props.isErrorMessage) {
                    console.log(response.message);
                }
                toast.current.show({ severity: 'error', detail: 'Hata oluştu' });
                return;
            }
            if (response.data.length)
                setNeighbourhoods(response.data);
        }).catch(e => {

            if (props.isErrorMessage) {

                console.log(e);
            }
        });
    }
    const getRoads = (value) => {

        service.post(props.roadUrl, { parentId: value.id }, props.bms).then(response => {
            if (!response.success) {
                if (props.isErrorMessage) {
                    console.log(response.message);
                }

                toast.current.show({ severity: 'error', detail: 'Hata oluştu' });
                return;

            }
            if (response.data.length)
                setRoads(response.data);
        }).catch(e => {

            if (props.isErrorMessage) {

                console.log(e);
            }
        });
    }
    const getDoorNumbers = (value) => {

        service.post(props.doorNumberUrl, { parentId: value.id, id: value.csId }, props.bms).then(response => {
            if (!response.success) {
                if (props.isErrorMessage) {
                    console.log(response.message);
                }
                toast.current.show({ severity: 'error', detail: 'Hata oluştu' });
            }
            if (response.data.length)
                setDoorNumbers(response.data);
        }).catch(e => {

            if (props.isErrorMessage) {

                console.log(e);
            }
        });
    }

    const showMapWithButton = () => {

        if (selectedDoorNumber)
            showWithGeojsonGeojson(selectedDoorNumber.geoloc, props.doorNumberStyle)
        else if (selectedRoad) {
            showWithGeojsonGeojson(selectedRoad.geoloc, props.roadStyle);

        }
        else if (selectedNeighbourhod)
            getMap(props.neighbourhoodUrl, selectedNeighbourhod.id, true, props.neighbourhoodStyle);
        else if (selectedDistrict)
            getMap(props.districtUrl, selectedDistrict.id, true, props.districtStyle);
        else if (selectedCity)
            getMap(props.cityUrl, selectedCity.id, true, props.cityStyle);
    }

    return (
        <div id={props.id ? props.id : "bms-hierarchial-layer"}>
            <Toast ref={toast} />
            <h3 id={props.id + "-title"}>  {props.title}  </h3>
            {(cities.length > 0 || props.showAll) && <Dropdown filterLocale="tr" resetFilterOnHide="true" filter value={selectedCity} onChange={(e) => {
                setSelectedCity(e.value);
                setSelectedDistrict(null);
                setSelectedNeighbourhod(null);
                setSelectedRoad(null);
                setSelectedDoorNumber(null);
                setDistricts([]);
                setNeighbourhoods([]);
                setRoads([]);
                setDoorNumbers([]);
                getDistricts(e.value);
                if (props.showSelect) {

                    getMap(props.cityUrl, e.value.id, true, props.cityStyle);
                }
            }} options={cities} optionLabel="name"
                placeholder={props.selectedCityLabel ? props.selectedCityLabel : "Selecr city"} />}



            {props.items.includes("district") && (districts.length > 0 || props.showAll) && <Dropdown filterLocale="tr" resetFilterOnHide="true" filter value={selectedDistrict} onChange={(e) => {
                setSelectedDistrict(e.value);
                getNeighbourhoods(e.value);
                setNeighbourhoods([]);
                setSelectedRoad(null);
                setSelectedDoorNumber(null);
                setRoads([]);
                setDoorNumbers([]);
                if (props.showSelect) {
                    getMap(props.districtUrl, e.value.id, true, props.districtStyle);
                }
            }} options={districts} optionLabel="name"
                placeholder={props.selectedDistrictLabel ? props.selectedDistrictLabel : "Select District"} />}



            {props.items.includes("neighbourhood") && (neighbourhoods.length > 0 || props.showAll) && <Dropdown filterLocale="tr" resetFilterOnHide="true" filter value={selectedNeighbourhod} onChange={(e) => {

                setSelectedNeighbourhod(e.value);
                setSelectedRoad(null);
                setSelectedDoorNumber(null);
                setRoads([]);
                setDoorNumbers([]);
                getRoads(e.value);
                if (props.showSelect) {
                    getMap(props.neighbourhoodUrl, e.value.id, true, props.neighbourhoodStyle);
                }
            }} options={neighbourhoods} optionLabel="name"
                placeholder={props.selectedNeighbourhoodLabel ? props.selectedNeighbourhoodLabel : "Select neighbourhood"} />}


            {props.items.includes("road") && (roads.length > 0 || props.showAll) && <Dropdown filterLocale="tr" resetFilterOnHide="true" filter value={selectedRoad} onChange={(e) => {
                console.log(e.value);
                setSelectedDoorNumber(null)
                getDoorNumbers(e.value);
                setSelectedRoad(e.value)
                if (props.showSelect) {
                    showWithGeojsonGeojson(e.value.geoloc, props.roadStyle);
                }
            }} options={roads} optionLabel="name"
                placeholder={props.selectedRoadLabel ? props.selectedRoadLabel : "Selected Road"} />}

            {props.items.includes("doorNumber") && (doorNumbers.length > 0 || props.showAll) && <Dropdown filterLocale="tr" resetFilterOnHide="true" filter value={selectedDoorNumber} onChange={(e) => {
                getDoorNumbers(e.value);
                setSelectedDoorNumber(e.value)
                if (props.showSelect) {
                    showWithGeojsonGeojson(e.value.geoloc, props.doorNumberStyle);
                    //getMap(props.doorNumberUrl, e.value.id, props.showDoorNumber, props.doorNumberStyle);

                }
            }} options={doorNumbers} optionLabel="name"
                placeholder={props.selectedDoorNumberLabel ? props.selectedDoorNumberLabel : "Selected DoorNumber"} />}

            {/* <div className="button-group">

                {props.showMapButton && <Button onClick={showMapWithButton} label="Göster" severity="primary" />}
                {props.showClearButton && <Button onClick={reset} label="Temizle" severity="secondary" />}

            </div> */}

            <div className="card flex justify-content-center" style={{ flexDirection: "column" }}>

                {props.showMapButton && <Button className='mt-2 w-full' onClick={showMapWithButton} label="Göster" severity="primary" />}
                {props.showClearButton && <Button label="Temizle" link onClick={reset} />}
            </div>

            <br />

        </div>


    )
}

export default BmsHierarchicalQuery;